import { MapLayer, MapLayers } from 'features/mapping/mapping.constants';

export const MIGRATION_VERSION_KEY = 'MAP_LAYERS_MIGRATION_VERSION';

// Ordered list of default-state changes — the array index + 1 represents the
// migration version. Each entry maps layer keys to their new default value.
export const MIGRATIONS: Partial<Record<MapLayer, boolean>>[] = [
  { [MapLayers.FLOOD_WEATHER]: true }, // Version 1
  // { [MapLayers.SOME_FUTURE_LAYER]: false }, // Version 2, etc.
];
